export const hasSlot = {
  methods: {
    $hasSlot(slotName) {
      return !!this.$slots[slotName];
    }
  }
};
